<template>
  <photo-list
    v-if="!readOnly || securityPhotos.length"
    v-model="photosByReason"
    class="md-layout-item md-size-100"
    image-actions
    :concepts-order="firstReasons"
    :isExtranet="isExtranet"
    :show-labels="showDateLabels"
    :missingConcepts="missingReasons"
  >
    <template slot="image-actions" slot-scope="{ image: photo }">
      <md-button
        v-if="canRejectPhoto(photo)"
        class="md-just-icon md-round reject"
        @click="rejectMap[photo.id] = !rejectMap[photo.id]"
        :class="{
          'md-danger': rejectMap[photo.id],
          'md-secondary': !rejectMap[photo.id],
        }"
      >
        <md-icon>backspace</md-icon>
        <md-tooltip class="md-primary">Presione el boton para rechazar la foto</md-tooltip>
      </md-button>
      <md-button
        v-if="photo && photo.original.isRejected"
        @click="toEditItem(photo)"
        class="md-primary md-just-icon md-round edit"
      >
        <md-icon>edit</md-icon>
        <md-tooltip class="md-primary" :disabled="false">Cambiar foto</md-tooltip>
      </md-button>
    </template>

    <br />
    <md-divider class="md-inset"></md-divider>

    <photo-concept-uploader
      ref="photoUploader"
      :concepts="reasons"
      :todayImage="true"
      @sendedPhotos="uploadPhotos"
      @updatedSelectedConcept="newPhotoReasonId = $event"
      v-if="!readOnly"
      :loading="uploading"
    />

    <md-speed-dial class="md-bottom-right float-right" v-show="!!toRejectImages.length">
      <md-speed-dial-target class="md-info md-round md-just-icon big-button" @click="addComment">
        <md-icon>cancel_presentation</md-icon>
        <md-tooltip>
          <span v-show="!!toRejectImages.length">
            Se recharazá{{ toRejectImages.length === 1 ? "" : "n" }}
            {{ toRejectImages.length }} foto{{
            toRejectImages.length === 1 ? "" : "s"
            }}.
          </span>
        </md-tooltip>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="md-fab md-danger md-round md-just-icon" @click="resetMarked">
          <md-icon>close</md-icon>
          <md-tooltip>Quitar selecciones</md-tooltip>
        </md-button>
      </md-speed-dial-content>
    </md-speed-dial>

    <DialogRejectFiles
      class="dialog-reject"
      :dialog="dialog1"
      @rejectFiles="rejectPhotos"
      @close="dialog1 = false"
      only-free-text
    />
    <input ref="imgFile" type="file" style="display: none" @change="onChangeImage" />
  </photo-list>

  <loading-content
    v-else
    :loading="loading"
    class="md-layout-item md-size-100 md-accent"
    empty-icon="photo_library"
    :empty-label="!isExtranet ? 'Sin fotos de seguridad' : ''"
    :empty-description="emptyDescription"
  />
</template>

<script>
import {
  PhotoList,
  DialogRejectFiles,
  ImageField,
  PhotoConceptUploader,
} from "@/components";
import workPlanService from "@/services/workPlan";
import { iterateDelayed } from "@/utils";

import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import { mapPermissions } from "@/plugins/accountPermissions/";

const IMPORTANT_REASONS = ["COIA"];

export default {
  name: "SecurityPhotos",

  mixins: [usesAccountInfoMixin],

  components: {
    ImageField,
    PhotoList,
    PhotoConceptUploader,
    DialogRejectFiles,
  },

  props: {
    realPlan: Object,
    reasons: {
      type: Array,
      default: () => [],
    },
    affectedId: {
      type: Number,
      required: false,
    },
    forceReadOnly: {
      type: Boolean,
      default: false,
    },
    isES: {
      type: Boolean,
      default: false,
    },
    isCP: {
      type: Boolean,
      default: false,
    },
    isExtranet: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    fetchSecurityPhotos() {
      this.loading = true;
      const realPlan = this.realPlan;
      const fetchInfo = {
        day: this.date,
        extranet: this.isExtranet ? this.isExtranet : undefined,
      };

      if (realPlan) {
        fetchInfo.realPlan = realPlan.id;
      } else {
        fetchInfo.affected = this.affectedId;
      }

      workPlanService
        .fetchSecurityPhotos(fetchInfo)
        .then((securityPhotos) => {
          this.loading = false;
          this.securityPhotos = [...securityPhotos];
          this.$emit("dateRange", securityPhotos);
          this.resetMarked();
        })
        .catch((error) => {
          this.loading = false;
          this.$fireErrorResponse(error);
        });

      const securityPhoto = {
        reason: null,
        photo: null,
        workPlanReal: realPlan && realPlan.id,
      };

      this.securityPhoto = securityPhoto;
    },

    uploadPhotos(photos) {
      this.toUploadPhotos = photos;
      this.$nextTick(() => this.sendPhotos());
    },

    sendPhotos() {
      const securityPhotos = this.newPhotos;

      if (!securityPhotos) {
        return;
      }

      this.uploading = true;

      this.$refs.photoUploader.unloadPhotos();

      return iterateDelayed(securityPhotos, 500, this.sendPhoto).then(() => {
        this.uploading = false;
        this.$emit("uploadedPhotos", securityPhotos);
      });
    },
    sendPhoto(photo) {
      return workPlanService
        .sendSecurityPhoto(photo)
        .then((securityPhoto) => {
          this.securityPhotos.push(securityPhoto);
          // this.$emit('photosUpdated', this.realPlan)
        })
        .catch((err) => {
          this.$notify({
            message: `Ocurrio un error subiendo la foto. ${err}`,
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.$refs.photoUploader.loadPhotos(files);
    },
    save() {
      this.$emit("saved", this.securityPhoto);
    },
    rejectImages(photo) {
      if (this.toRejectImages.some((r) => r.id === photo.id)) {
        const index = this.toRejectImages.indexOf(photo);
        this.toRejectImages[index] = photo;
      } else {
        this.toRejectImages.push(photo);
      }
    },
    resetMarked() {
      const map = {};
      this.securityPhotos.forEach((photo) => {
        map[photo.id] = false;
      });
      this.rejectMap = { ...map };
    },
    addComment() {
      this.dialog1 = true;
    },
    rejectPhotos(comment_) {
      const payload = {
        photos: this.toRejectImages.map((img) => img.id),
        comment: comment_,
      };
      workPlanService
        .rejectSecurityPhotos(payload)
        .then(() => {
          this.dialog1 = false;
          this.$emit("refresh");
          this.fetchSecurityPhotos();
          this.$successMessage({ title: `Fotos rechazadas` });
        })
        .catch(this.$fireErrorResponse);
    },

    updateSecurityPhotos(payload) {
      return workPlanService
        .updateSecurityPhotos(payload)
        .then(() => {
          this.$emit("refresh");
          this.fetchSecurityPhotos();
          this.toEditPhoto = null;
          this.$successMessage({ title: "Foto cambiada" });
        })
        .catch(this.$fireErrorResponse);
    },

    toEditItem(photo) {
      this.toEditPhoto = photo.id;
      this.$refs.imgFile.click();
    },

    onChangeImage(e) {
      const files = e.target.files;
      const ext = files[0].name.split(".").pop();
      const validExt = ["jpg", "jpeg", "png"];
      if (validExt.some((v) => v === ext)) {
        const formData = new FormData();
        formData.append("photo_id", this.toEditPhoto);
        formData.append("file", files[0]);
        this.updateSecurityPhotos(formData);
      } else {
        this.$alertMessage({ title: "Formato de archiv incorrecto" });
      }
    },
    canRejectPhoto(photo) {
      return (
        !!photo &&
        !photo.original.isRejected &&
        this.canDeleteSecurityphotos &&
        (this.isES || this.isCP)
      );
    },
  },

  watch: {
    realPlan: {
      immediate: true,
      handler() {
        this.fetchSecurityPhotos();
      },
    },
    affectedId: {
      immediate: true,
      handler: "fetchSecurityPhotos",
    },
    allReasonsUploaded(value) {
      this.$emit("allReasonsUploaded", value);
    },
  },

  created() {
    this.today = new Date();
  },

  computed: {
    ...mapPermissions("WorkPlan", "securityphotos"),
    date() {
      const { realPlan } = this;
      if (!realPlan) {
        return;
      }
      return realPlan.date;
    },
    photosByReason() {
      const photos = this.securityPhotos;

      const obj = {};

      for (const photo of photos) {
        const reasonName = photo.reason.name;
        const stuff = obj[reasonName];
        const photoObj = {
          id: photo.id,
          src: photo.photo,
          thumb: photo.smallPhoto,
          conceptName: reasonName,
          label: photo.date,
          original: {
            isRejected: photo.isRejected,
          },
        };
        if (!stuff) {
          obj[reasonName] = [photoObj];
        } else {
          stuff.push(photoObj);
        }
      }

      return obj;
    },
    missingReasons() {
      const photosByReason = this.photosByReason;
      return this.reasons
        .filter((reason) => !photosByReason[reason.name])
        .map((reason) => reason.name);
    },
    allReasonsUploaded() {
      const missingReasons = this.missingReasons;
      return missingReasons && !missingReasons.length;
    },
    emptyDescription() {
      if (this.readOnly) {
        return "No se subieron fotos este dia.";
      }

      return "No se han subido fotos";
    },
    readOnly() {
      const realPlan = this.realPlan;
      return this.forceReadOnly || (realPlan && realPlan.readOnly);
    },
    newPhotos() {
      const toUploadPhotos = this.toUploadPhotos || [];
      const reasonId = this.newPhotoReasonId;
      const workPlanReal = this.realPlan.id;

      if (!reasonId) {
        return;
      }

      return toUploadPhotos.map((photo) => ({
        ...photo,
        photo: photo.file,
        photoImage: photo.src,
        reasonId,
        workPlanReal,
      }));
    },
    finishsToday() {
      const { realPlan } = this;
      return realPlan && realPlan.finishsToday;
    },
    showDateLabels() {
      return !this.date;
    },
    toRejectImages() {
      const keys = Object.keys(this.rejectMap).map((key) => ({
        id: key,
        reject: this.rejectMap[key],
      }));
      return keys.filter((key) => key.reject === true);
    },
    firstReasons() {
      const { reasons } = this;
      return IMPORTANT_REASONS.map((iCode) =>
        reasons.find(({ code }) => code === iCode)
      )
        .filter((reason) => !!reason)
        .map(({ name }) => name);
    },
  },

  data() {
    return {
      rejectMap: {},
      toUploadPhotos: null,
      uploading: null,
      loading: false,
      today: null,
      securityPhotos: [],
      newPhotoReasonId: null,
      dialog1: false,
      toEditPhoto: null,
    };
  },
};
</script>

<style lang="less" scoped>
.float-right {
  float: right;
  position: absolute;
}
.dialog-reject {
  z-index: 110;
}
.delete {
  top: 32px;
  right: 2px;
}
.reject {
  top: 0px;
  right: 2px;
}
.edit {
  top: 0px;
  right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/SecurityPhotos.vue